<div class="loading-overlay" [hidden]="!service.viewModel.isLoadingConfiguration">
	<img class="spinner" src="./assets/spinner2.gif" />
</div>
<div class="scrollable-section" [hidden]="service.viewModel.isLoadingConfiguration">
	<div class="flex gap-16 flex-align-center">
		<h2 class="mat-heading flex-1">
			{{ 'masterdata.palletising.configuration.label' | translate }}
		</h2>
		<header-sub-menu [favoriteItems]="favoriteItems" [menuItems]="menuItems"></header-sub-menu>
	</div>
	<mat-accordion multi [@.disabled]="true">
		<mat-expansion-panel expanded="true">
			<mat-expansion-panel-header>
				<mat-panel-title>
					{{ 'masterdata.palletising.configuration.pallet' | translate }}
				</mat-panel-title>
				<div class="v-divider"></div>
			</mat-expansion-panel-header>
			<form class="flex flex-dir-col mw-400 pt-16 gap-8" [formGroup]="service.viewModel.form">
				@for (item of service.viewModel.formFieldsLookup; track item.property) {
					<mat-form-field appearance="outline" class="dialog">
						@if (service.viewModel.controls) {
							<mat-error>
								{{ 'masterdata.palletising.configuration.errors.validation.' + item.property | translate }}
							</mat-error>
						}
						<mat-label class="mat-body-1">
							{{ 'masterdata.palletising.configuration.' + item.property | translate }}
						</mat-label>
						@if (item.property === 'rotateMaxLengthToHeightAspectRatio') {
							<input OnlyDecimal matInput formControlName="{{ item.property }}" (blur)="updateConfiguration()" [(ngModel)]="service.viewModel[item.property]" />
						} @else {
							<input OnlyNumbers matInput formControlName="{{ item.property }}" (blur)="updateConfiguration()" [(ngModel)]="service.viewModel[item.property]" />
						}
					</mat-form-field>
				}

				<mat-checkbox disabled="{{ service.viewModel.form.invalid }}" [(ngModel)]="service.viewModel.rotateMinRatioSingleElementOnly" [ngModelOptions]="{ standalone: true }" (ngModelChange)="updateConfiguration()">
					{{ 'masterdata.palletising.configuration.rotateMinRatioSingleElementOnly' | translate }}
				</mat-checkbox>

				<mat-checkbox disabled="{{ service.viewModel.form.invalid }}" [ngModelOptions]="{ standalone: true }" [(ngModel)]="service.viewModel.allowStackingWithoutSupportingBase" (ngModelChange)="updateConfiguration()">
					{{ 'masterdata.palletising.configuration.allowStackingWithoutSupportingBase' | translate }}
				</mat-checkbox>
			</form>
		</mat-expansion-panel>
		<mat-expansion-panel>
			<mat-expansion-panel-header>
				<mat-panel-title>
					{{ 'masterdata.palletising.configuration.strategies' | translate }}
				</mat-panel-title>
				<div class="v-divider"></div>
			</mat-expansion-panel-header>
			<div class="flex flex-dir-col pt-16 gap-8 mw-700">
				<h2 class="m-0">
					{{ 'masterdata.palletising.configuration.sorting.label' | translate }}
				</h2>
				@for (item of service.viewModel.sortingFormFieldsLookup; track item.property) {
					<div class="flex gap-64">
						<mat-checkbox class="flex-1" [(ngModel)]="service.viewModel[item.property]" (ngModelChange)="updateConfiguration()">
							{{ 'masterdata.palletising.configuration.sorting.' + item.property | translate }}
						</mat-checkbox>
						<mat-checkbox [(ngModel)]="service.viewModel[item.property + 'Order']" disabled="{{ !service.viewModel[item.property] }}" (ngModelChange)="updateConfiguration()">
							{{ 'masterdata.palletising.configuration.sorting.ascending' | translate }}
						</mat-checkbox>
						<mat-form-field [formGroup]="service.viewModel.sortingPriorityForm" appearance="outline" class="dialog mw-200">
							@if (service.viewModel.sortingPriorityControls[item.property + 'Priority'].invalid && service.viewModel.sortingPriorityControls[item.property + 'Priority'].touched) {
								<mat-error>
									{{ 'masterdata.palletising.configuration.errors.validation.priority' | translate }}
								</mat-error>
							}
							<mat-label class="mat-body-1">
								{{ 'masterdata.palletising.configuration.priority' | translate }}
							</mat-label>
							<input OnlyPositiveIntegers matInput formControlName="{{ item.property + 'Priority' }}" (blur)="updateConfiguration()" (ngModelChange)="updatePriorityFormValidity()" [(ngModel)]="service.viewModel[item.property + 'Priority']" />
						</mat-form-field>
					</div>
				}
				<h2 class="m-0">
					{{ 'masterdata.palletising.configuration.pooling.label' | translate }}
				</h2>
				@for (item of service.viewModel.poolingFormFieldsLookup; track item.property) {
					<div class="flex gap-64">
						<mat-checkbox class="flex-1" [(ngModel)]="service.viewModel[item.property]" (ngModelChange)="updateConfiguration()">
							{{ 'masterdata.palletising.configuration.pooling.' + item.property | translate }}
						</mat-checkbox>
						<mat-checkbox [(ngModel)]="service.viewModel[item.property + 'Order']" disabled="{{ !service.viewModel[item.property] }}" (ngModelChange)="updateConfiguration()">
							{{ 'masterdata.palletising.configuration.pooling.poolUnspecified' | translate }}
						</mat-checkbox>
						<mat-form-field [formGroup]="service.viewModel.poolingPriorityForm" appearance="outline" class="dialog mw-200">
							@if (service.viewModel.poolingPriorityControls[item.property + 'Priority'].invalid && service.viewModel.poolingPriorityControls[item.property + 'Priority'].touched) {
								<mat-error>
									{{ 'masterdata.palletising.configuration.errors.validation.priority' | translate }}
								</mat-error>
							}
							<mat-label class="mat-body-1">
								{{ 'masterdata.palletising.configuration.priority' | translate }}
							</mat-label>
							<input OnlyPositiveIntegers matInput [formControlName]="item.property + 'Priority'" (blur)="updateConfiguration()" (ngModelChange)="updatePriorityFormValidity()" [(ngModel)]="service.viewModel[item.property + 'Priority']" />
						</mat-form-field>
					</div>
				}
				<h2 class="m-0">
					{{ 'masterdata.palletising.configuration.balancing.label' | translate }}
				</h2>
				<mat-form-field appearance="outline">
					<mat-select [(ngModel)]="service.viewModel.balancingMethod" (ngModelChange)="updateConfiguration()">
						<mat-option value="-1">
							{{ 'masterdata.palletising.configuration.balancing.none' | translate }}
						</mat-option>
						<mat-option value="0">
							{{ 'masterdata.palletising.configuration.balancing.uniform' | translate }}
						</mat-option>
						<mat-option value="1">
							{{ 'masterdata.palletising.configuration.balancing.edge' | translate }}
						</mat-option>
						<mat-option value="2">
							{{ 'masterdata.palletising.configuration.balancing.center' | translate }}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
		</mat-expansion-panel>
		<mat-expansion-panel>
			<mat-expansion-panel-header>
				<mat-panel-title>
					{{ 'masterdata.palletising.configuration.stacking.label' | translate }}
				</mat-panel-title>
				<div class="v-divider"></div>
			</mat-expansion-panel-header>
			<div class="flex pt-16 flex-dir-col align-items-flex-end gap-16">
				<button class="gap-16" mat-flat-button color="primary" (click)="openCreateUpdateStackParam()">
					{{ 'masterdata.palletising.configuration.stacking.createLabel' | translate }}
					<mat-icon svgIcon="acies_add"></mat-icon>
				</button>
				<app-generictable class="align-self-stretch" [tableSource]="service.viewModel.tableSource" [tableColumns]="service.viewModel.tableColumns" [rowActions]="service.viewModel.rowActions" (menuEmitter)="handleRowMenuAction($event)"></app-generictable>
			</div>
		</mat-expansion-panel>
		<!-- Layers -->
		<mat-expansion-panel>
			<mat-expansion-panel-header>
				<mat-panel-title>
					{{ 'masterdata.palletising.configuration.layers.label' | translate }}
				</mat-panel-title>
				<div class="v-divider"></div>
			</mat-expansion-panel-header>
			<div class="flex pt-16 flex-dir-col align-items-flex-end gap-16">
				<button class="gap-16" mat-flat-button color="primary" (click)="openCreateUpdateLayerParam()">
					{{ 'masterdata.palletising.configuration.layers.createLabel' | translate }}
					<mat-icon svgIcon="acies_add"></mat-icon>
				</button>
				<app-generictable class="align-self-stretch" [tableSource]="service.viewModel.layersTableSource" [tableColumns]="service.viewModel.layersColumns" [rowActions]="service.viewModel.layerRowActions" (menuEmitter)="handleLayerRowMenuAction($event)"></app-generictable>
			</div>
		</mat-expansion-panel>
		<mat-expansion-panel>
			<mat-expansion-panel-header>
				<mat-panel-title>
					{{ 'masterdata.palletising.configuration.palletTypes.palletCombinations' | translate }}
				</mat-panel-title>
				<div class="v-divider"></div>
			</mat-expansion-panel-header>
			<div class="pt-16">
				<div class="flex gap-16">
					<h2 class="flex-1 m-0">
						{{ 'masterdata.palletising.configuration.palletTypes.types' | translate }}
					</h2>
					<div class="v-spacer"></div>
					<h2 class="flex-1 m-0">
						{{ 'masterdata.palletising.configuration.palletTypes.associated' | translate }}
					</h2>
				</div>
				<div class="flex gap-16">
					<mat-selection-list class="flex-1" multiple="false">
						@for (item of service.viewModel.palletTypes; track item) {
							<mat-list-option (selectedChange)="palletTypeSelected(item)">
								{{ item.name }}
							</mat-list-option>
						}
					</mat-selection-list>
					<div class="v-spacer line"></div>
					<div class="flex flex-1">
						<mat-selection-list [disabled]="service.viewModel.isUpdatingConfiguration" [style.visibility]="service.viewModel.selectedPalletType ? 'visible' : 'hidden'" class="flex-1" (selectionChange)="updateConfiguration()">
							@for (item of service.viewModel.filteredAssociatedTypes; track item) {
								<mat-list-option [(selected)]="item.selected">
									{{ item.name }}
								</mat-list-option>
							}
						</mat-selection-list>
					</div>
				</div>
			</div>
		</mat-expansion-panel>
	</mat-accordion>
</div>
